// Sites & units (0029): pure helpers for the register screen.
import type { Tone } from '@/components/ui'
import type { RegistrySite, SiteRegistryView } from '@/domain/registry'

/** "Ready" when nothing is missing, else how many items are. */
export function siteReadiness(site: RegistrySite): { tone: Tone; label: string } {
  if (site.missing.length === 0) return { tone: 'ok', label: 'Ready for permits' }
  return { tone: 'warn', label: `${site.missing.length} to do` }
}

/** Units without a work-location classification block permits at that unit. */
export function unclassifiedCount(site: RegistrySite): number {
  return site.units.filter((u) => !u.location_classification).length
}

export function clientOptions(view: SiteRegistryView): { value: string; label: string }[] {
  return view.organisations.filter((o) => o.kind === 'client').map((o) => ({ value: o.id, label: o.name }))
}

/** Rulebook versions an issuing authority may be anchored to (not withdrawn). */
export function anchorVersionOptions(view: SiteRegistryView): { value: string; label: string }[] {
  return view.policy_versions.map((v) => ({ value: v.id, label: `${v.label} (${v.lifecycle})` }))
}

/** A register code as the server stores it: trimmed and upper-cased. */
export function normaliseCode(v: string): string {
  return v.trim().toUpperCase()
}

/** Client-side check matching the server's: 2 to 20 capital letters, digits or hyphens. */
export function codeProblem(v: string): string | null {
  return /^[A-Z0-9][A-Z0-9-]{1,19}$/.test(normaliseCode(v)) ? null : '2 to 20 letters, digits or hyphens.'
}

/** Optional text: trimmed, null when blank. */
export function optional(v: string): string | null {
  const t = v.trim()
  return t ? t : null
}
